import React from "react";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";
import styled from "styled-components";
import RadioButtonComponent from "../RadioButtonComponent";
import TextFields from "../TextField/text-field.component";
import { Label, LargeInput } from "../PreviewOfPayment/PreviewOfPayment.styles";
import { AddUserFormValues } from "../../pages/AddUserPage/AddUser";

interface AddUserProps {
  formData: AddUserFormValues;
  selectedUserType: string;
  handleUserTypeChange: (userType: string, index: number) => void;
  handleChange: (
    key: keyof AddUserFormValues,
    value: string,
    index: number
  ) => void;
  isLoading?: boolean;
  errorMessage?: string;
  startAddingUser: () => void;
  showDelete: boolean;
  index: number;
  deleteUser: (index: number) => void;
  validationErrors: string | null;
}
const userTypes = [
  {
    label: "Administrator",
    value: "Administrator",
    description: "Monitor and manage financial activities by users",
  },
  {
    label: "Standard User",
    value: "Standard User",
    description: "Perform specific actions authorized by the account holder",
  },
  {
    label: "Basic User",
    value: "Basic User",
    description: "Perform basic reporting duties",
  },
];

const AddUserContainer: React.FC<AddUserProps> = ({
  formData,
  selectedUserType,
  handleUserTypeChange,
  handleChange,
  startAddingUser,
  showDelete,
  index,
  deleteUser,
  validationErrors,
}) => {
  return (
    <div>
      <Hrule />
      <SubContainer>
        <SubTitleText>Select the type of user</SubTitleText>
        <CheckBoxStyle>
          <RadioButtonComponent
            onTypeChange={(userType) => handleUserTypeChange(userType, index)}
            itemTypes={userTypes}
            activeType={selectedUserType}
          />
        </CheckBoxStyle>
      </SubContainer>
      {selectedUserType && (
        <>
          <SubContainer>
            <SubTitleText>Enter {selectedUserType} Information</SubTitleText>
          </SubContainer>
          <TextFieldsContainer>
            <TextFields
              height="30px"
              width={"30vw"}
              type="text"
              placeholder=""
              fontSize={fipayFonts.fipayFonts.fontSize.body3}
              label="Full Name"
              value={formData.fullName}
              onChange={(value: string) =>
                handleChange("fullName", value, index)
              }
            />
            <TextFields
              height="30px"
              width={"30vw"}
              type="email"
              placeholder=""
              fontSize={fipayFonts.fipayFonts.fontSize.body3}
              label="Email Address"
              value={formData.email}
              onChange={(value: string) => handleChange("email", value, index)}
            />
          </TextFieldsContainer>

          <Label htmlFor="countryCode">Phone Number</Label>

          <LargeInput
            type="tel"
            onChange={(value: string) => handleChange("phone", value, index)}
            value={formData.phone}
            defaultCountry="US"
            maxLength={14}
          />

          {/* <PhoneContainer>
            <TextFields
              height="30px"
              width={"3vw"}
              type="number"
              placeholder="+1"
              fontSize={fipayFonts.fipayFonts.fontSize.body3}
              label=""
              value={""}
              onChange={() => {}}
            />
            <TextFields
              height="30px"
              width={"30vw"}
              type="tel"
              placeholder=""
              fontSize={fipayFonts.fipayFonts.fontSize.body3}
              label=""
              value={formData.phone}
              onChange={(value: string) => handleChange("phone", value, index)}
              maxLength={11}
            />
          </PhoneContainer> */}
          <AddUserStyle
            $showDelete={showDelete}
            onClick={showDelete ? () => deleteUser(index) : startAddingUser}
          >
            {validationErrors !== null && (
              <ValidationError>{validationErrors}</ValidationError>
            )}
            <p>{showDelete ? "Delete User Details" : "Add another user"}</p>
          </AddUserStyle>
        </>
      )}
    </div>
  );
};

export default AddUserContainer;

export const Hrule = styled.div`
  height: 1px;
  background: #e8eaed;
  width: 100%;
  padding: 0;
  margin: 0;
`;
export const SubContainer = styled.div`
  padding: 1rem;
`;
const SubTitleText = styled.p`
  font-size: ${fipayFonts.fipayFonts.body3.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};
  @media screen and (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.8rem;
  }
`;
export const CheckBoxStyle = styled.div`
  display: flex;
  gap: 1.5rem;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 4%;
  right: 4%;
  @media screen and (max-width: 767px) {
    bottom: 1%;
    right: 1%;
  }
`;
export const TextFieldsContainer = styled.div`
  display: flex;
  margin-bottom: 3rem;
  @media screen and (max-width: 767px) {
    gap: 2rem;
    display: flex;
    flex-direction: column;
  }
`;
export const PhoneContainer = styled.div`
  display: flex;
  margin: -1rem 0 3rem 0;
  & > div:nth-child(1) {
    @media screen and (max-width: 767px) {
      width: 25%;
    }
  }
  & > div:nth-child(2) {
    @media screen and (max-width: 767px) {
      width: 75%;
    }
  }
  @media screen and (max-width: 767px) {
    margin: -1rem 0 0 0;
    align-items: center;
    padding-left: 0.8rem;
  }
`;

export const AddUserStyle = styled.div<{ $showDelete: boolean }>`
  padding: 1rem;
  p {
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    color: ${({ $showDelete }) => ($showDelete ? colors.DANGER : colors.GREEN)};
    cursor: pointer;
  }
`;
export const ValidationError = styled.div`
  color: ${colors.DANGER};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};
`;
